import t from "@/lang/lang";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";
import { CardSkeleton } from "@/shared/components/card-skeleton";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { TextInputField } from "@/shared/components/field/input-field";
import { inputValidationErrorMessages } from "@/shared/components/errors/input-error-messages";
import { useOptimisticDebouncedMutation } from "@/shared/lib/debounce/use-optimistic-debounced-mutation";
import {
  updateMasterDataPdfCache,
  usePatchMasterDataPdfMutation,
  useShowMasterDataPdfQuery,
} from "@/services/backend/company/api/master-data-pdf";
import { MasterDataPdfDefault } from "@/services/backend/company/types/master-data-pdf";

export function MasterDataPdfGeneralCard({ id }: { id: string }) {
  const { data, error, isLoading } = useShowMasterDataPdfQuery({ id });

  return (
    <div>
      {data && <Content data={data} />}
      {error && <RTKQueryErrorAlert error={error} />}
      {isLoading && <CardSkeleton />}
    </div>
  );
}

function Content({ data }: { data: MasterDataPdfDefault }) {
  // The request is a partial patch, so each call passes the
  // optimistic cache value alongside it.
  const [set, { error }] = useOptimisticDebouncedMutation(
    { id: data.id },
    updateMasterDataPdfCache,
    usePatchMasterDataPdfMutation(),
  );

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("Allgemein")}</CardTitle>
        <CardDescription>
          {t(
            "Die Bezeichnung unterscheidet diese PDF-Template-Daten von den anderen des Unternehmens.",
          )}
        </CardDescription>
      </CardHeader>
      <CardContent className="grid gap-4 sm:grid-cols-2">
        <TextInputField
          label={t("Bezeichnung")}
          text={data.label}
          onTextChange={(label) =>
            set({ id: data.id, label }, { ...data, label })
          }
          errors={inputValidationErrorMessages(error, "label")}
        />
        <TextInputField
          label={t("Link zu den AGB")}
          description={t("Wird in Angeboten und Aufträgen abgedruckt.")}
          text={data.linkToAgb}
          onTextChange={(linkToAgb) =>
            set({ id: data.id, linkToAgb }, { ...data, linkToAgb })
          }
          errors={inputValidationErrorMessages(error, "linkToAgb")}
        />
      </CardContent>
    </Card>
  );
}
